import { render, staticRenderFns } from "./pageNav.vue?vue&type=template&id=090f92f8&scoped=true"
import script from "./pageNav.vue?vue&type=script&lang=js"
export * from "./pageNav.vue?vue&type=script&lang=js"
import style0 from "./pageNav.vue?vue&type=style&index=0&id=090f92f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090f92f8",
  null
  
)

export default component.exports